export const waitlistConfirmationTemplate = (firstName: string) => `
  <div style="font-family: sans-serif; max-width: 600px; margin: 0 auto;">
    <h2>Welcome to CloseCircle, ${firstName}!</h2>
    
    <p>Thank you for joining our waitlist. We're excited to have you as part of our growing community.</p>
    
    <p>We're working hard to create a safe and supportive space where meaningful connections can flourish. You'll be among the first to know when we launch.</p>
    
    <p>Stay tuned for updates and early access opportunities!</p>
    
    <p>Best regards,<br>The CloseCircle Team</p>
  </div>
`;